import React from 'react';
import Swal from 'sweetalert2';
import Sidebar from './Sidebar/Sidebar';
import { Toaster, toast } from 'sonner';
import { SnackbarProvider, useSnackbar } from 'notistack';
// import toast, { Toaster } from 'react-hot-toast';
// import { ToastContainer, toast } from "react-toastify";
const AlertButtons = () => {
  const { enqueueSnackbar } = useSnackbar();

  const handleSuccessToast = () => {
    toast.success("Comments submitted successfully!");
  };

  const handleErrorToast = () => {
    toast.error("Something went wrong while submitting!");
  };

  return (
    <div>
      {/* SweetAlert2 Examples */}
      <div className='flex flex-row gap-4 mb-4'>
        <button
          onClick={() => Swal.fire("Comment submitted successfully!")}
          className='p-4 bg-[#9369A9] text-white rounded-md'>
          Submit
        </button>

        <button
          onClick={() =>
            Swal.fire({
              title: "Submit Success!",
              icon: "success",
            })
          }
          className='p-4 bg-[#7ABD7E] text-white rounded-md'>
          Success
        </button>

        <button
          onClick={() =>
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            })
          }
          className='p-4 bg-[#CA585C] text-white rounded-md'>
          Error
        </button>
      </div>

      {/* Sonner Toast Examples */}
      <div className='flex flex-wrap gap-4 mb-4'>
        <button onClick={handleSuccessToast} className='p-3 bg-green-200 rounded'>
          Sonner Success
        </button>
        <button onClick={handleErrorToast} className='p-3 bg-red-200 rounded'>
          Sonner Error
        </button>
      </div>

      {/* Notistack Snackbar Examples */}
      <div className='flex flex-wrap gap-4'>
        <button
          onClick={() => enqueueSnackbar("Success!", { variant: "success" })}
          className='p-4 bg-green-300 rounded'>
          Snackbar Success
        </button>
        <button
          onClick={() => enqueueSnackbar("Error occurred!", { variant: "error" })}
          className='p-4 bg-red-300 rounded'>
          Snackbar Error
        </button>
      </div>

      {/* Sonner Toaster mount point */}
      <Toaster position="top-center" richColors />
    </div>
  );
};

export const Toast = () => {
  return (
    <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Sidebar>
        <AlertButtons />
      </Sidebar>
    </SnackbarProvider>
  );
};
